import React from 'react';
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import shuterup from '../../assets/shuterup/shuterup.png'

const ShuterUp = () => {
    const images = [
        { image: "https://i.ibb.co/98Sn2Kp/shuterup1.png" },
        {
            image: "https://i.ibb.co/10sb79Z/shuterup2.png",
        },
        {
            image: "https://i.ibb.co/cQzDPtm/shuterup3.png",
        },
        {
            image: "https://i.ibb.co/VqFqKkm/shuterup4.png",
        },
    ];
    return (
        <div>
            <img src={shuterup} className="w-full" alt="website" />
            <div className="w-full px-4 md:px-10 lg:p-0 lg:w-4/5 mx-auto flex justify-center items-center lg:items-start flex-col lg:flex-row mt-8 text-justify dark:text-[#E9F8F9]">
                <div className="w-full lg:w-[80%] lg:pr-8">
                    <h3 className="font-bold text-xl">Description</h3>
                    <div className="mt-5">
                        <h4>
                            ShuterUp is a full stack single photographer service
                            provider website.
                        </h4>
                        <ul className="list-disc ml-5 mt-3">
                            <li className="mb-2">
                                Users can create there account with email
                                password login, google login and it is created
                                by firebase authentication.
                            </li>
                            <li className="mb-2">
                                If users not login they cannot post their
                                review.
                            </li>
                            <li className="mb-2">
                                User can see others review.
                            </li>
                            <li className="mb-2">
                                Users can delete or update their review.
                            </li>
                            <li className="mb-2">
                                Review route is protected by JWT.
                            </li>
                        </ul>
                    </div>
                    {/* <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
                        <img src={regameDetails1} alt="" />
                        <img src={regameDetails2} alt="" />
                        <img src={regameDetails3} alt="" />
                        <img src={regameDetails4} alt="" />
                    </div> */}
                    <Swiper
                        className="mt-8 w-96 md:w-10/12 cursor-grab"
                        modules={[Pagination]}
                        spaceBetween={40}
                        slidesPerView={1}
                        pagination={{ clickable: true }}
                    >
                        {images.map((photo, id) => (
                            <SwiperSlide className="rounded-lg" key={id}>
                                <img
                                    className="rounded-lg pb-10"
                                    src={photo.image}
                                    alt=""
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <h3 className="font-bold text-xl">Technologies Used</h3>
                    <div className="mt-5">
                        <ul className="list-disc ml-5 mt-3">
                            <li className="mb-2">React.js</li>
                            <li className="mb-2">Tailwind CSS</li>
                            <li className="mb-2">DaisyUi</li>
                            <li className="mb-2">Firebase</li>
                            <li className="mb-2">Node.js</li>
                            <li className="mb-2">JWT</li>
                            <li className="mb-2">MondoDb</li>
                            <li className="mb-2">Express.js</li>
                            <li className="mb-2">React Router Dom</li>
                            <li className="mb-2">React-Toastify</li>
                        </ul>
                    </div>
                </div>

                <div className="w-full my-8 lg:mt-0 lg:w-1/4 lg:pr-5">
                    <h3 className="font-bold text-xl">Details</h3>

                    <div>
                        <h4 className="font-semibold mt-3">Live Site</h4>
                        <a
                            href="https://shutter-up-12025.web.app/"
                            rel="noreferrer"
                            target="_blank"
                        >
                            ShuterUp
                        </a>
                    </div>

                    <div>
                        <h4 className="font-semibold mt-3">Client Side Code</h4>
                        <a
                            href="https://github.com/nabilAhmedN/shutter-up"
                            rel="noreferrer"
                            target="_blank"
                        >
                            ./<span className="underline">nabilAhmedN</span>/
                            <span className="underline">
                                <span className="underline">shutterUp</span>
                            </span>
                        </a>
                    </div>

                    <div>
                        <h4 className="font-semibold mt-3">Server Side Code</h4>
                        <a
                            href="https://github.com/nabilAhmedN/shutter-up-server"
                            rel="noreferrer"
                            target="_blank"
                        >
                            ./<span className="underline">nabilAhmedN</span>/
                            <span className="underline">
                                <span className="underline">
                                    shutterUp-server
                                </span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShuterUp;